"use strict";

var _defineProperty = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var genStepsCustomIconStyle = function genStepsCustomIconStyle(token) {
  var _ref;

  var componentCls = token.componentCls,
      stepsIconCustomTop = token.stepsIconCustomTop,
      stepsIconCustomSize = token.stepsIconCustomSize,
      stepsIconCustomFontSize = token.stepsIconCustomFontSize;
  return _ref = {}, _defineProperty(_ref, "".concat(componentCls, "-item-custom"), _defineProperty({}, "> ".concat(componentCls, "-item-container > ").concat(componentCls, "-item-icon"), _defineProperty({
    height: 'auto',
    background: 'none',
    border: 0
  }, "> ".concat(componentCls, "-icon"), {
    top: stepsIconCustomTop,
    width: stepsIconCustomSize,
    height: stepsIconCustomSize,
    fontSize: stepsIconCustomFontSize,
    lineHeight: "".concat(stepsIconCustomSize, "px")
  }))), _defineProperty(_ref, "&:not(".concat(componentCls, "-vertical)"), _defineProperty({}, "".concat(componentCls, "-item-custom"), _defineProperty({}, "".concat(componentCls, "-item-icon"), {
    width: 'auto',
    background: 'none'
  }))), _ref;
};

var _default = genStepsCustomIconStyle;
exports.default = _default;